const BASE = process.env.REACT_APP_API_URL || '/administration/api';

const get = (resource) =>
  fetch(`${BASE}/${resource}`)
    .then(r => r.ok ? r.json() : [])
    .catch(() => []);

const post = (resource, data) =>
  fetch(`${BASE}/${resource}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }).then(async (r) => {
    const json = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(json.error || 'Erreur serveur');
    return json;
  });

export const publicApi = { get, post };
